document.addEventListener('DOMContentLoaded', function () {
  mountMobileModals();
  initModalOpen();
  initModalClose();
  initProductQuickAddButtons();
  initDesktopHoverQuickAdd();
});

document.addEventListener('filters:updated', () => {
  mountMobileModals();
  initModalOpen();
  initModalClose();
  initProductQuickAddButtons();
  initDesktopHoverQuickAdd();
});

window.mountMobileModals = mountMobileModals;
window.initModalOpen = initModalOpen;
window.initModalClose = initModalClose;
window.initProductQuickAddButtons = initProductQuickAddButtons;
window.initDesktopHoverQuickAdd = initDesktopHoverQuickAdd;

function mountMobileModals() {
  document.querySelectorAll('.odd-quick-add-modal--mobile').forEach((modal) => {
    if (modal.dataset.mountedToBody === 'true') return;
    document.body.appendChild(modal);
    modal.dataset.mountedToBody = 'true';
  });
}

function initModalOpen() {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  document.querySelectorAll('odd-modal-opener').forEach((opener) => {
    if (opener.dataset.modalInit === 'true') return;

    const modalSelector = opener.dataset.modal;
    const modalMobileSelector = opener.dataset.modalMobile;
    const button = opener.querySelector('.odd-quick-add__button');

    if (!button) return;

    button.addEventListener('click', () => {
      const targetSelector = isMobile() && modalMobileSelector ? modalMobileSelector : modalSelector;
      const modal = targetSelector ? document.querySelector(targetSelector) : null;

      if (!modal) return;

      modal.classList.add('odd-quick-add-modal--active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      opener.classList.add('odd-modal-opener--hidden');
    });

    opener.dataset.modalInit = 'true';
  });
}

function initModalClose() {
  document.querySelectorAll('.odd-quick-add-modal').forEach((modal) => {
    if (modal.dataset.closeInit === 'true') return;

    modal.querySelectorAll('[data-modal-close]').forEach((closer) => {
      closer.addEventListener('click', () => closeModal(modal));
    });

    modal.dataset.closeInit = 'true';
  });
}

function closeModal(modal) {
  modal.classList.remove('odd-quick-add-modal--active');
  modal.setAttribute('aria-hidden', 'true');

  const openerSelector = modal.classList.contains('odd-quick-add-modal--mobile')
    ? `[data-modal-mobile="#${modal.id}"]`
    : `[data-modal="#${modal.id}"]`;

  document.querySelectorAll(`odd-modal-opener${openerSelector}`).forEach((opener) => {
    opener.classList.remove('odd-modal-opener--hidden');
  });

  if (!document.querySelector('.odd-quick-add-modal.odd-quick-add-modal--active')) {
    document.body.classList.remove('modal-open');
  }
}

function initProductQuickAddButtons() {
  document.querySelectorAll('odd-modal-opener .odd-quick-add__button').forEach((button) => {
    if (button.dataset.quickAddInit === 'true') return;

    button.addEventListener('click', () => {
      const productUrl = button.dataset.productUrl;
      const opener = button.closest('odd-modal-opener');
      const productId = opener?.dataset.productId;

      const modalSelector = opener?.dataset.modal;
      const modalMobileSelector = opener?.dataset.modalMobile;

      const modal = modalSelector ? document.querySelector(modalSelector) : null;
      const modalMobile = modalMobileSelector ? document.querySelector(modalMobileSelector) : null;

      if (!productUrl || !productId) return;

      if (button.dataset.quickAddLoaded === 'true' || button.dataset.quickAddLoading === 'true') {
        return;
      }

      button.dataset.quickAddLoading = 'true';

      fetch(`${productUrl}.js`)
        .then((res) => {
          return res.text().then((text) => {
            try {
              return JSON.parse(text);
            } catch (err) {
              console.error('Invalid JSON response:', text);
              throw err;
            }
          });
        })
        .then((product) => {
          renderOddQuickAddModal(product, productId, { modal, modalMobile });
          button.dataset.quickAddLoaded = 'true';
        })
        .catch((err) => {
          console.error('Error fetching product:', err);
        })
        .finally(() => {
          button.dataset.quickAddLoading = 'false';
        });
    });

    button.dataset.quickAddInit = 'true';
  });
}

function renderOddQuickAddModal(product, productId, { modal, modalMobile } = {}) {
  const optionNames = product.options;
  const variants = product.variants;

  const option1Values = [...new Set(variants.map((v) => v.option1).filter(Boolean))];
  const option2Values = [...new Set(variants.map((v) => v.option2).filter(Boolean))];
  const hasOption2 = option2Values.length > 0;

  const option1Container = document.getElementById(`odd-option1-buttons-${productId}`);
  const option2Container = document.getElementById(`odd-option2-buttons-${productId}`);
  const option1Label = document.getElementById(`odd-option1-label-${productId}`);
  const option2Label = document.getElementById(`odd-option2-label-${productId}`);
  const availabilityMsg = document.getElementById(`odd-availability-msg-${productId}`);

  const option1ContainerMobile = document.getElementById(`odd-mobile-option1-buttons-${productId}`);
  const option2ContainerMobile = document.getElementById(`odd-mobile-option2-buttons-${productId}`);
  const option1LabelMobile = document.getElementById(`odd-mobile-option1-label-${productId}`);
  const option2LabelMobile = document.getElementById(`odd-mobile-option2-label-${productId}`);
  const availabilityMsgMobile = document.getElementById(`odd-mobile-availability-msg-${productId}`);

  const addToCartButtons = [
    document.getElementById(`odd-add-to-cart-btn-${productId}`),
    document.getElementById(`odd-mobile-add-to-cart-btn-${productId}`),
  ].filter(Boolean);

  if (!option1Container || !option1Label || !availabilityMsg) return;

  const desktopModalEl = document.getElementById(`OddQuickAdd-${productId}`);
  const mobileModalEl = document.getElementById(`OddQuickAddMobile-${productId}`);
  const isPreorderProduct = !!(desktopModalEl && desktopModalEl.dataset.preorderDate) || !!(mobileModalEl && mobileModalEl.dataset.preorderDate);
  const dispatchDate = desktopModalEl?.dataset.preorderDate || mobileModalEl?.dataset.preorderDate || '';

  syncOptionLabels(optionNames, option1Label, option2Label);
  syncOptionLabels(optionNames, option1LabelMobile, option2LabelMobile);

  const optionLabels = {
    option1: optionNames[0]?.name || 'Option 1',
    option2: optionNames[1]?.name || 'Option 2',
  };

  const selected = { option1: null, option2: null };

  function getMatchingVariant() {
    if (!selected.option1) return null;
    if (hasOption2 && !selected.option2) return null;

    const matchingVariants = variants.filter((v) => {
      if (v.option1 !== selected.option1) return false;
      if (hasOption2 && v.option2 !== selected.option2) return false;
      return true;
    });

    if (!matchingVariants.length) return null;

    const availableMatch = matchingVariants.find((variant) => variant.available);
    return availableMatch || matchingVariants[0];
  }

  function tryAddToCart() {
    const matchingVariant = getMatchingVariant();

    if (matchingVariant && (matchingVariant.available || isPreorderProduct)) {
      const cartBody = {
        id: matchingVariant.id,
        quantity: 1,
        sections: 'cart-drawer',
      };

      if (isPreorderProduct && dispatchDate) {
        cartBody.properties = { 'Expected dispatch': dispatchDate };
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartBody),
      })
        .then((res) => res.json())
        .then((data) => {
          updateAvailabilityMessage('Added!');
          resetOptionSelection(selected, option1Container, option2Container);
          resetOptionSelection(selected, option1ContainerMobile, option2ContainerMobile);
          closeModals();
          updateAvailabilityMessage('');
          updateAddToCartButtons();

          const cartDrawer = document.querySelector('cart-drawer');
          if (data.sections && data.sections['cart-drawer'] && cartDrawer) {
            cartDrawer.dispatchEvent(new CustomEvent('cartDrawerUpdate', {
              detail: data.sections['cart-drawer'],
            }));
          }

          requestAnimationFrame(() => {
            openCartDrawer();
          });
        })
        .catch((err) => {
          console.error('Error adding to cart:', err);
          updateAvailabilityMessage('An error occurred when adding to cart.');
          updateAddToCartButtons();
        });
    } else {
      updateAvailabilityMessage('Selected variant is unavailable.');
      updateAddToCartButtons();
    }
  }

  function updateAvailabilityMessage(message) {
    if (availabilityMsg) availabilityMsg.textContent = message;
    if (availabilityMsgMobile) availabilityMsgMobile.textContent = message;
  }

  function updateAddToCartButtons() {
    const missingOptions = [];
    if (option1Values.length && !selected.option1) missingOptions.push(optionLabels.option1);
    if (hasOption2 && !selected.option2) missingOptions.push(optionLabels.option2);

    const matchingVariant = missingOptions.length === 0 ? getMatchingVariant() : null;

    addToCartButtons.forEach((button) => {
      if (!button) return;

      if (missingOptions.length > 1) {
        button.disabled = true;
        button.dataset.preorderConfirmed = 'false';
        button.textContent = 'CHOOSE OPTIONS';
      } else if (missingOptions.length === 1) {
        button.disabled = true;
        button.dataset.preorderConfirmed = 'false';
        button.textContent = `SELECT ${missingOptions[0].toUpperCase()}`;
      } else if (!matchingVariant || !matchingVariant.available) {
        button.disabled = true;
        button.dataset.preorderConfirmed = 'false';
        button.textContent = 'NOTIFY ME';
      } else {
        button.disabled = false;
        button.textContent = isPreorderProduct ? 'PRE-ORDER' : 'ADD TO CART';
        if (isPreorderProduct) {
          button.dataset.preorderConfirmed = 'true';
        }
      }
    });
  }

  function resetOptionSelection(selected, option1Container, option2Container) {
    selected.option1 = null;
    selected.option2 = null;

    if (option1Container) {
      option1Container.querySelectorAll('.odd-option-btn').forEach((btn) => {
        btn.classList.remove('active');
      });
    }

    if (option2Container) {
      renderOption2Buttons(null, option2Container, option2Values, variants, initOptionSelection);
    }

    updateAddToCartButtons();
  }

  function closeModals() {
    document.querySelectorAll('.odd-quick-add-modal.odd-quick-add-modal--active').forEach((modal) => closeModal(modal));
  }

  function initOptionSelection(container, optKey) {
    if (!container) return;

    container.querySelectorAll('.odd-option-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const val = btn.dataset.value;

        // OOS — open Klaviyo BIS directly
        if (btn.classList.contains('odd-option-btn--unavailable')) {
          if (window.klaviyo) window.klaviyo.openForm('WpVmZQ');
          return;
        }

        setTimeout(() => {
          const currentVariant = getMatchingVariant();
          let variantInputs = document.querySelectorAll('.odd-quick-add-modal--active [name="id"]');
          variantInputs.forEach((variantInput) => {
            if (currentVariant) variantInput.value = currentVariant.id;
          });
        }, 350);

        if (selected[optKey] === val) {
          selected[optKey] = null;
          btn.classList.remove('active');

          if (optKey === 'option1' && option2Container) {
            selected.option2 = null;
            renderOption2Buttons(null, option2Container, option2Values, variants, initOptionSelection);
          }

          if (optKey === 'option1' && option2ContainerMobile) {
            selected.option2 = null;
            renderOption2Buttons(null, option2ContainerMobile, option2Values, variants, initOptionSelection);
          }

          if (optKey === 'option2' && option2ContainerMobile) {
            option2ContainerMobile.querySelectorAll('.odd-option-btn').forEach((b) => b.classList.remove('active'));
          }

          updateAvailabilityMessage('');
          updateAddToCartButtons();
          return;
        }

        if (selected[optKey] !== val) {
          selected[optKey] = val;

          container.querySelectorAll('.odd-option-btn').forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');

          if (optKey === 'option1' && option2Container) {
            selected.option2 = null;
            renderOption2Buttons(selected.option1, option2Container, option2Values, variants, initOptionSelection);
          }

          if (optKey === 'option1' && option2ContainerMobile) {
            selected.option2 = null;
            renderOption2Buttons(
              selected.option1,
              option2ContainerMobile,
              option2Values,
              variants,
              initOptionSelection
            );
          }

          if (optKey === 'option2' && option2ContainerMobile) {
            const mobileButton = option2ContainerMobile.querySelector(`.odd-option-btn[data-value="${val}"]`);
            option2ContainerMobile.querySelectorAll('.odd-option-btn').forEach((b) => b.classList.remove('active'));
            if (mobileButton) mobileButton.classList.add('active');
          }

          updateAvailabilityMessage('');
          updateAddToCartButtons();
        }
      });
    });
  }

  // Render buttons first, then attach listeners
  renderOptionButtons(option1Container, option1Values, variants, 'option1');
  renderOptionButtons(option1ContainerMobile, option1Values, variants, 'option1');

  if (option2Container) {
    renderOption2Buttons(null, option2Container, option2Values, variants, initOptionSelection);
  }

  if (option2ContainerMobile) {
    renderOption2Buttons(null, option2ContainerMobile, option2Values, variants, initOptionSelection);
  }

  initOptionSelection(option1Container, 'option1');
  initOptionSelection(option1ContainerMobile, 'option1');

  availabilityMsg.textContent = '';
  if (availabilityMsgMobile) availabilityMsgMobile.textContent = '';

  addToCartButtons.forEach((button) => {
    if (!button) return;

    if (button.__oddQuickAddHandler) {
      button.removeEventListener('click', button.__oddQuickAddHandler);
    }

    const handler = () => {
      if (button.disabled) return;
      tryAddToCart();
    };

    button.addEventListener('click', handler);
    button.__oddQuickAddHandler = handler;
  });

  updateAddToCartButtons();

  // Protect pre-order button text from being overwritten by third-party apps
  addToCartButtons.forEach((button) => {
    if (!isPreorderProduct) return;

    const observer = new MutationObserver(() => {
      if (button.dataset.preorderConfirmed === 'true' && button.textContent.trim() !== 'PRE-ORDER') {
        button.textContent = 'PRE-ORDER';
      }
    });

    observer.observe(button, { childList: true, subtree: true, characterData: true });
  });
}

function syncOptionLabels(optionNames, option1Label, option2Label) {
  if (!option1Label) return;
  option1Label.textContent = optionNames[0]?.name || '';
  if (option2Label) {
    option2Label.textContent = optionNames[1]?.name || '';
  }
}

function renderOptionButtons(container, values, variants, optionKey) {
  if (!container) return;

  container.innerHTML = values
    .map((val) => {
      const isAvailable = optionKey === 'option1' ? isOption1Available(val, variants) : true;
      const className = `odd-option-btn${!isAvailable ? ' odd-option-btn--unavailable' : ''}`;
      return `<button type="button" class="${className}" data-option="${optionKey}" data-value="${val}">${val}</button>`;
    })
    .join('');
}

function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer');

  if (drawer) {
    drawer.classList.remove('is-empty');

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      const cartIcon = document.querySelector('.header__icon--cart');
      if (cartIcon) cartIcon.click();
    }
  }
}

function isOption1Available(val, variants) {
  return variants.some((v) => v.option1 === val && v.available);
}

function isOption2Available(val, selectedOption1, variants) {
  if (!selectedOption1) {
    return variants.some((v) => v.option2 === val && v.available);
  }
  return variants.some((v) => v.option1 === selectedOption1 && v.option2 === val && v.available);
}

function renderOption2Buttons(selectedOption1, option2Container, option2Values, variants, initOptionSelection) {
  if (!option2Container) return;

  option2Container.innerHTML = option2Values
    .map((val) => {
      const isAvailable = isOption2Available(val, selectedOption1, variants);
      const className = `odd-option-btn${!isAvailable ? ' odd-option-btn--unavailable' : ''}`;
      return `<button type="button" class="${className}" data-option="option2" data-value="${val}">${val}</button>`;
    })
    .join('');

  initOptionSelection(option2Container, 'option2');
}

function initDesktopHoverQuickAdd() {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const applyHoverListeners = () => {
    document.querySelectorAll('.product-card-wrapper').forEach((wrapper) => {
      if (wrapper.dataset.quickAddHoverInit === 'true') return;

      const opener = wrapper.querySelector('odd-modal-opener');
      const button = opener?.querySelector('.odd-quick-add__button');
      const modalSelector = opener?.dataset.modal;
      const modal = modalSelector ? document.querySelector(modalSelector) : null;
      let hoverTimeout = null;

      const clearHoverTimeout = () => {
        if (hoverTimeout) {
          window.clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
      };

      const scheduleClose = () => {
        clearHoverTimeout();
        if (!modal) return;
        if (modal.classList.contains('odd-quick-add-modal--active')) {
          closeModal(modal);
        }
      };

      if (!opener || !button) {
        wrapper.dataset.quickAddHoverInit = 'true';
        return;
      }

      wrapper.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;
        clearHoverTimeout();

        const activeModal = document.querySelector('.odd-quick-add-modal.odd-quick-add-modal--active');
        if (activeModal && modal && activeModal.id !== modal.id) {
          closeModal(activeModal);
        }

        if (modal && modal.classList.contains('odd-quick-add-modal--active')) return;
        if (document.body.classList.contains('modal-open') && !modal) return;

        button.click();
      });

      wrapper.addEventListener('mouseleave', () => {
        if (!desktopQuery.matches) return;
        clearHoverTimeout();
        hoverTimeout = window.setTimeout(scheduleClose, 150);
      });

      if (modal) {
        modal.addEventListener('mouseenter', clearHoverTimeout);
        modal.addEventListener('mouseleave', () => {
          if (!desktopQuery.matches) return;
          clearHoverTimeout();
          hoverTimeout = window.setTimeout(scheduleClose, 150);
        });
      }

      wrapper.dataset.quickAddHoverInit = 'true';
    });
  };

  applyHoverListeners();

  desktopQuery.addEventListener('change', () => {
    if (!desktopQuery.matches) return;
    applyHoverListeners();
  });
}